import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useIsPrint = (): IGlobalStore['is_print'] => {
  return useSelector((store: IReducerStore) => store.global.is_print);
};
